import { render } from "./PostcodeSelectionView.vue?vue&type=template&id=68472396"
import script from "./PostcodeSelectionView.vue?vue&type=script&lang=js"
export * from "./PostcodeSelectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__